/* Careatic — rain canvas (ported from shared.jsx RainCanvas).
   DESKTOP ONLY (mobile gets rain baked into the art), density-capped,
   IntersectionObserver-paused off-screen, disabled under prefers-reduced-motion.
   Attaches to every [data-ca-rain] container. data-density / data-color optional. */
(function () {
  'use strict';
  var MOBILE = window.matchMedia('(max-width: 767px)');
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function mount(container) {
    if (container.dataset.caRainBound) return;
    container.dataset.caRainBound = '1';
    if (MOBILE.matches || REDUCED.matches) return; // no live particles

    var density = parseInt(container.dataset.density || '90', 10);
    var color = container.dataset.color || 'rgba(255,255,255,0.35)';
    var canvas = document.createElement('canvas');
    canvas.className = 'ca-rain';
    canvas.setAttribute('aria-hidden', 'true');
    container.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    var raf, running = true, w = 0, h = 0;
    var drops = [];

    function resize() {
      var r = container.getBoundingClientRect();
      w = canvas.width = r.width; h = canvas.height = r.height;
      drops.length = 0;
      var n = Math.min(density, Math.round((w * h) / 9000));
      for (var i = 0; i < n; i++) {
        drops.push({ x: Math.random() * w, y: Math.random() * h, l: 8 + Math.random() * 14, v: 4 + Math.random() * 4 });
      }
    }
    function draw() {
      if (!running) return;
      ctx.clearRect(0, 0, w, h);
      ctx.strokeStyle = color; ctx.lineWidth = 1.1; ctx.lineCap = 'round';
      for (var i = 0; i < drops.length; i++) {
        var d = drops[i];
        ctx.beginPath(); ctx.moveTo(d.x, d.y); ctx.lineTo(d.x - 1.5, d.y + d.l); ctx.stroke();
        d.y += d.v; d.x -= 0.4;
        if (d.y > h) { d.y = -d.l; d.x = Math.random() * w; }
      }
      raf = requestAnimationFrame(draw);
    }
    resize();
    window.addEventListener('resize', resize);
    var io = new IntersectionObserver(function (entries) {
      running = entries[0].isIntersecting;
      if (running) { raf = requestAnimationFrame(draw); } else { cancelAnimationFrame(raf); }
    }, { threshold: 0.05 });
    io.observe(canvas);
    raf = requestAnimationFrame(draw);
  }

  function init() {
    document.querySelectorAll('[data-ca-rain]').forEach(mount);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
